export default __webpack_public_path__ + "static/media/logo.c694b3ff.png";